import { observer } from 'mobx-react-lite'
import React from 'react'
import { Modal } from '@mantine/core'
import { useStore } from '../../stores/store'

export default observer(function ModalContainer () {
  const { modalStore } = useStore()

  return (
    <Modal
      opened={modalStore.modal.open}
      onClose={modalStore.closeModal}
      size="sm"
      withCloseButton
      title={null}
    >
      {modalStore.modal.body}
    </Modal>
  )
})
